import inventoryText from "../inventoryI18n.js";
import React, { useState, useEffect, useContext } from "react";
import WarehouseTable from "./WarehouseTable";
import Modal from "react-bootstrap/Modal";
import AddWarehouse from "./WarehouseAdd";

import AuthContext from "../../context/AuthContext";
import axios from "axios";
import { API_URL } from "../../components/api";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faTachometerAlt,
  faUsers,
  faUser,
  faWifi,
  faList,
  faCog,
} from "@fortawesome/free-solid-svg-icons";
import { NavLink } from "react-router-dom";
import "../Purchases/Purchases.css";
import "../Products/ProductEdit.css";
import "./WarehouseModal.css";

function Warehouse() {
  const [show, setShow] = useState(false);
  const [records, setRecords] = useState([]);
  const [recordsLoading, setRecordsLoading] = useState(false);
  const [recordsError, setRecordsError] = useState("");
  const [recordsSearch, setRecordsSearch] = useState("");

  const [showAdd, setShowAdd] = useState(false);
  const handleCloseAdd = () => setShowAdd(false);

  const handleShowAdd = () => setShowAdd(true);
  const { user } = useContext(AuthContext);
  const [data, setData] = useState([]);
  const [showBelowMin, setShowBelowMin] = useState(false);
  const [belowMin, setBelowMin] = useState([]);
  const [belowMinLoading, setBelowMinLoading] = useState(false);
  const [belowMinError, setBelowMinError] = useState("");

  const handleClose = () => {
    setShow(false);
    setRecordsSearch("");
  };

  const handleShow = async () => {
    setShow(true);
    setRecords([]);
    setRecordsError("");
    setRecordsSearch("");
    setRecordsLoading(true);

    try {
      const authTokens = JSON.parse(
        localStorage.getItem("authTokens") || "{}"
      );
      const response = await axios.get(
        `${API_URL}/inventory/warehouses/transfer-records/`,
        {
          headers: {
            Authorization: `Bearer ${authTokens.access}`,
          },
          params: {
            username: user.username,
          },
        }
      );

      setRecords(
        Array.isArray(response.data)
          ? response.data
          : []
      );
    } catch (error) {
      console.error(
        "Unable to load all warehouse records:",
        error
      );
      setRecordsError(
        error.response?.data?.message
          || "Inventory records could not be loaded."
      );
    } finally {
      setRecordsLoading(false);
    }
  };

  const normalizedRecordsSearch = (
    recordsSearch.trim().toLowerCase()
  );
  const filteredRecords = normalizedRecordsSearch
    ? records.filter((record) => {
        const displayedDate = record.creation_date
          ? new Date(record.creation_date).toLocaleString()
          : "";
        return (
          `${JSON.stringify(record)} ${displayedDate}`
            .toLowerCase()
            .includes(normalizedRecordsSearch)
        );
      })
    : records;

  const openBelowMin = async () => {
    setShowBelowMin(true);
    setBelowMin([]);
    setBelowMinError("");
    setBelowMinLoading(true);

    try {
      const authTokens = JSON.parse(localStorage.getItem("authTokens"));
      const response = await axios.get(
        `${API_URL}/inventory/warehouses/below-minimum/`,
        {
          headers: {
            Authorization: `Bearer ${authTokens.access}`,
          },
        }
      );
      setBelowMin(Array.isArray(response.data) ? response.data : []);
    } catch (error) {
      console.error(error);
      setBelowMinError(
        error.response?.data?.message
        || inventoryText("inventory.BelowMinimumLoadFailed")
      );
    } finally {
      setBelowMinLoading(false);
    }
  };

  const closeBelowMin = () => setShowBelowMin(false);

  const exportBelowMinCsv = () => {
    const headers = [
      inventoryText("inventory.Warehouse"),
      inventoryText("inventory.Product"),
      inventoryText("inventory.Quantity"),
      inventoryText("inventory.MinQuantity"),
      inventoryText("inventory.NeededQuantity"),
    ];
    const escape = (value) =>
      `"${String(value ?? "").replace(/"/g, '""')}"`;
    const lines = [headers.map(escape).join(",")];
    belowMin.forEach((row) => {
      lines.push([
        row.warehouse_name || "",
        row.name || "",
        row.quantity,
        row.min_quantity,
        row.needed_quantity,
      ].map(escape).join(","));
    });
    const blob = new Blob(
      ["\ufeff" + lines.join("\r\n")],
      { type: "text/csv;charset=utf-8;" }
    );
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = "products_below_minimum.csv";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const authTokens = JSON.parse(localStorage.getItem("authTokens"));
        const response = await axios.get(`${API_URL}/administration/groups/`, {
          headers: {
            Authorization: `Bearer ${authTokens.access}`,
          },
          params: {
            username: user.username,
          },
        });

        if (response.status === 200) {
          setData(response.data);
        }
      } catch (error) {
        console.error(error);
      }
    };

    fetchData();
  }, [user.username]);
  return (
    <div className="Plans">
      <div className="main">
        <div>
          <button onClick={handleShowAdd} className="AddClient">{inventoryText("inventory.AddWarehouse")}</button>

          <button onClick={handleShow} className="AddClient">{inventoryText("inventory.ViewAllRecords")}</button>

          {data === "yes" && (
            <button onClick={openBelowMin} className="AddClient">{inventoryText("inventory.BelowMinimum")}</button>
          )}

          <NavLink
            exact
            to="/inventory"
            activeClassName="active"
            className="AddClient"
          >{inventoryText("inventory.GoBack")}</NavLink>
        </div>
        <WarehouseTable />
      </div>

      <Modal
        show={show}
        onHide={handleClose}
        className="purchase-modal warehouse-transfer-records-modal"
        centered
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>{inventoryText("inventory.AllWarehouseRecords")}</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <input
            type="search"
            className="warehouse-transfer-records-search"
            placeholder={inventoryText("inventory.SearchAllRecords")}
            value={recordsSearch}
            onChange={(event) => setRecordsSearch(event.target.value)}
            aria-label="Search all warehouse records"
          />

          {recordsLoading ? (
            <div
              className="warehouse-inventory-state"
              role="status"
            >
              Loading records…
            </div>
          ) : recordsError ? (
            <div
              className="warehouse-transfer-error"
              role="alert"
            >
              {recordsError}
            </div>
          ) : records.length === 0 ? (
            <div className="warehouse-inventory-state">{inventoryText("inventory.NoTransferRecordsAreAvailable")}</div>
          ) : filteredRecords.length === 0 ? (
            <div className="warehouse-inventory-state">{inventoryText("inventory.NoRecordsMatchYourSearch")}</div>
          ) : (
            <div className="warehouse-transfer-records-list">
              {filteredRecords.map((record) => (
                <article
                  className="warehouse-transfer-record"
                  key={record.record_id}
                >
                  <div
                    className="warehouse-transfer-record-description"
                  >
                    {record.description}
                  </div>
                  <div
                    className="warehouse-transfer-record-reason"
                  >
                    <strong>Reason:</strong>{" "}
                    {record.reason}
                  </div>
                  <time dateTime={record.creation_date}>
                    {new Date(
                      record.creation_date
                    ).toLocaleString()}
                  </time>
                </article>
              ))}
            </div>
          )}
        </Modal.Body>

        <Modal.Footer>
          <button
            type="button"
            className={
              "purchase-button "
              + "purchase-button-secondary"
            }
            onClick={handleClose}
          >{inventoryText("inventory.Close")}</button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showBelowMin}
        onHide={closeBelowMin}
        className="purchase-modal warehouse-transfer-records-modal"
        centered
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>{inventoryText("inventory.BelowMinimumTitle")}</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {belowMin.length > 0 && (
            <div className="warehouse-below-min-toolbar">
              <button
                type="button"
                className="purchase-button"
                onClick={exportBelowMinCsv}
              >{inventoryText("inventory.ExportCSV")}</button>
            </div>
          )}
          {belowMinLoading ? (
            <div className="warehouse-inventory-state" role="status">
              {inventoryText("inventory.Loading")}
            </div>
          ) : belowMinError ? (
            <div className="warehouse-transfer-error" role="alert">
              {belowMinError}
            </div>
          ) : belowMin.length === 0 ? (
            <div className="warehouse-inventory-state">{inventoryText("inventory.NoProductsBelowMinimum")}</div>
          ) : (
            <div className="warehouse-inventory-table-wrap">
              <table className="warehouse-inventory-table">
                <thead>
                  <tr>
                    <th>{inventoryText("inventory.Warehouse")}</th>
                    <th>{inventoryText("inventory.Product")}</th>
                    <th>{inventoryText("inventory.Quantity")}</th>
                    <th>{inventoryText("inventory.MinQuantity")}</th>
                    <th>{inventoryText("inventory.NeededQuantity")}</th>
                  </tr>
                </thead>
                <tbody>
                  {belowMin.map((row) => (
                    <tr key={row.inventory_id}>
                      <td>{row.warehouse_name || "—"}</td>
                      <td>{row.name || "—"}</td>
                      <td className="warehouse-inventory-quantity">
                        {Number(row.quantity).toLocaleString("en-US")}
                      </td>
                      <td className="warehouse-inventory-quantity">
                        {Number(row.min_quantity).toLocaleString("en-US")}
                      </td>
                      <td className="warehouse-inventory-quantity">
                        {Number(row.needed_quantity).toLocaleString("en-US")}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </Modal.Body>

        <Modal.Footer>
          <button
            type="button"
            className={
              "purchase-button "
              + "purchase-button-secondary"
            }
            onClick={closeBelowMin}
          >{inventoryText("inventory.Close")}</button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showAdd}
        onHide={handleCloseAdd}
        className="purchase-modal product-edit-modal product-add-modal warehouse-add-modal"
      >
        <div className="forma">
          <Modal.Header closeButton>
            <Modal.Title>{inventoryText("inventory.AddWarehouse")}</Modal.Title>
          </Modal.Header>
          <AddWarehouse />
        </div>
      </Modal>
    </div>
  );
}

export default Warehouse;
